
































import Vue from 'vue'

export default Vue.extend({
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    dialogCssClasses(): any[] {
      return [{ 'is-visible': this.isVisible }]
    },
  },
  methods: {
    closeDialog(): void {
      this.$emit('closeDialog')
    },
    handleKeyPress(e: KeyboardEvent): void {
      if (e.key !== 'Escape') return
      this.closeDialog()
    }
  },
  data() {
    return {
      onKeyPress: (e: KeyboardEvent) => {}
    }
  },
  created() {
    this.onKeyPress = this.handleKeyPress.bind(this)
  },
  mounted(): void {
    // this.positionDialog()
  },
  destroyed(): void {
    window.removeEventListener('keydown', this.onKeyPress)
  },
  watch: {
    isVisible(val) {
      if (!val) {
        document.body.removeAttribute('style')
        window.removeEventListener('keydown', this.onKeyPress)
        this.$emit('onCloseDialog')
        return
      }

      document.body.style.overflow = 'hidden'
      window.addEventListener('keydown', this.onKeyPress)

      // Vue.nextTick(() => this.positionDialog())

      this.$emit('onShowDialog')
    }
  }
})
